angular
  .module('contrast.factory.sso', [])
  .factory('SSOFactory', function ($http, UserService) {
    return {
      testSAMLConfig: function (data) {
        return $http.post(UserService.buildAPIUrl('/saml/verify'), data)
      },
      getSAMLConfig: function () {
        return $http.get(UserService.buildAPIUrl('/saml'))
      },
      addSAMLConfig: function (data) {
        return $http.post(UserService.buildAPIUrl('/saml'), data)
      },
      editSAMLConfig: function (data) {
        return $http.put(UserService.buildAPIUrl('/saml'), data)
      },
      deleteSAMLConfig: function () {
        return $http.delete(UserService.buildAPIUrl('/saml'))
      }
    }
  })
